import store from '@/store/store'

export const authUrl = process.env.VUE_APP_AUTH_URL
export const authApiToken = process.env.VUE_APP_UNOAPP_API_TOKEN

export const signageUrl = process.env.VUE_APP_SIGNAGE_URL
export const signageApiToken = process.env.VUE_APP_SIGNAGE_TOKEN

export const locationUrl = process.env.VUE_APP_LOCATIONS_URL
export const locationApiToken = process.env.VUE_APP_LOCATIONS_API_TOKEN

export const deviceManagementUrl = process.env.VUE_APP_DEVICEMANAGEMENT_URL
export const deviceManagementApiToken = process.env.VUE_APP_DEVICEMANAGEMENT_API_TOKEN

export const authToken = () => store.getters['auth/user'].token
